export function checkForAnyUnpaidRespondents(userSignupItem) {
  if (!userSignupItem || userSignupItem.respondents?.length === 0) return false;

  return userSignupItem.respondents?.some((r) => r.paymentStatus === "Unpaid");
}
